<app-table
    [items]="store.items()"
    [columns]="columns"
    [tableTitle]="(prefix + 'title') | translate"
    [translatePrefix]="prefix"
    [hideCheckboxes]="true"
    (createCallback)="openDialog()"
    (detailCallback)="openDialog($event)"
>
    <ng-template pTemplate="parentId" let-item="item">
        @if (item.parent) {
            <div>{{ item.parent.name }}</div>
        }
    </ng-template>
</app-table>
